import * as Parse from 'parse';

export enum Roles {
    Translator,
    Admin,
    Editor,
    ContentManager,
    All
}

export class Model extends Parse.User {
    public static async getRole() {
        const cUser = this.current();
        if (cUser) {
            const uQ = new Parse.Query(Model).equalTo('objectId', cUser!.id);
            return (await new Parse.Query(Parse.Role).matchesQuery('users', uQ).find())[0];
        } 
        return
    }

    public static async getRoleName() {
        return this.current()?(await this.getRole())!.get('name'):null;
    }

    public static checkRoleAccess(roles: any[], role: string): boolean {
        roles = roles.map(r => Roles[r].toLowerCase());
        return roles.indexOf(role) !== -1 ? true : false
    }
}

Parse.Object.registerSubclass('_User', Model);


// WEBPACK FOOTER //
// ./src/models/User.ts